"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBAlertNotification", {
  enumerable: true,
  get: function get() {
    return _SVBAlertNotification.default;
  }
});
var _SVBAlertNotification = _interopRequireDefault(require("./src/SVBAlertNotification"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }